const normalize = (s) => (s || '').replace(/[^a-z0-9]/gi, '').toUpperCase();

let abbrevSet = new Set();
let loadPromise = null;

export function setSpellCheckWhitelistWords(words) {
  const list = Array.isArray(words) ? words : [];
  abbrevSet = new Set(list.map(normalize).filter(Boolean));
}

// 'fetchWords' is injected by the caller (returns a Promise of string[]), so
// this module never imports the service layer
export function loadAbbreviations(fetchWords) {
  if (loadPromise) return loadPromise;

  // Promise.resolve().then(fetchWords) so a missing/throwing fetcher still
  // lands in the catch instead of throwing synchronously
  loadPromise = Promise.resolve()
    .then(fetchWords)
    .then((words) => {
      setSpellCheckWhitelistWords(words);
    })
    .catch((err) => {
      // eslint-disable-next-line no-console
      console.error('Failed to load abbreviations whitelist', err);
      abbrevSet = new Set();
      loadPromise = null;
    });

  return loadPromise;
}

export function isAbbreviation(word) {
  const normalized = normalize(word);

  // Accept simple plural forms (OPLAN -> OPLANs, MET -> METs)
  return (
    abbrevSet.has(normalized) ||
    (normalized.length > 1 &&
      normalized.endsWith('S') &&
      abbrevSet.has(normalized.slice(0, -1)))
  );
}
